

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click=handleClick(faq)>
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【计费】亚马逊FBA仓费用怎么计算？',
      answer: '自 2018 年 2 月 22 日起，亚马逊官方将开始按照商品体积（长 x 宽 x 高，以英寸为单位）除以 139（而不是之前的 166）这种方式来计算体积重量。体积重量仅适用于重量超过 1 磅的大号标准尺寸商品以及所有小号、中号和大号大件商品。请注意，体积重量还用于计算多渠道配送费用和库存配置服务费用。'
    },
    {
      id:'2',
      question: '【账号注册】亚马逊全球开店需要具备什么条件？',
      answer: '首先是个人账号所需资料,北美站： 1、电子邮箱地址；2、个人名称、地址、联系方式；3、可以支付美元的双币信用卡（Visa 等）；4、在注册期间可以联系到您的电话号码。个人卖家的月租金是39.99 美元/月。日本站：1、电子邮箱地址； 2、个人名称、地址、联系方式； 3、 国际信用卡（Visa, MasterCard 等）；4、 银行帐号信息 ；5在注册期间可以联系到你的电话号码；个人卖家的月租金是4900 日元/月。欧洲站：1、电子邮箱地址； 2、个人名称、地址、联系方式； 3、 国际信用卡（Visa, MasterCard 等）；4、 银行帐号信息 ；5在注册期间可以联系到你的电话号码；个人卖家的月租金是25 英镑/月。公司账号所需资料:北美站：1、营业执照、2、VISA双币信用 卡、3、 收款账号、4、身份证。欧洲站：1、营业执照和身份证、2、法人或者 受益人承债信用卡、3、收款账户。日本站：1、营业执照和身份证、2、VISA或者JCB 双币信用卡、3、 收款账户。'
    },
    {
      id:"3",
      question: '【亚马逊开店】在亚马逊欧洲开店，需要哪些基本费用？',
      answer: '分个人销售及专业销售计划，“个人销售计划”会被收取按件收费的费用，而“专业销售计划”账户则需要支付月度的订阅费。个人销售计划：免月租费、 按件收费（0.75 英镑/件 ）、销售佣金（根据不同品类亚马逊收取不同比例的佣金，一般为 8%-15%）专业销售计划：25 英镑/月、按件收费（免费 ）、（根据不同品类亚马逊收取不同比例的佣金，一般为 8%-15%）销售佣金：卖家为每件所售商品支付销售佣金。月租金：即亚马逊网站使用费，按月收取。'
    },
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>